// extracted by mini-css-extract-plugin
export default {"link":"NN-z","disabled":"ON-z"};